import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-symptom-checker-result',
  templateUrl: './symptom-checker-result.component.html',
  styleUrls: ['./symptom-checker-result.component.scss', '../../../../../assets/css/care-sphere-md3.css']
})
export class SymptomCheckerResultComponent implements OnInit {

  @Input() regId: string;
  @Input() visitId: number;
  @Input() result: any = {};

  trackByIndex(index: number): number {
    return index;
  }

  objectKeysLength(obj: any): number {
    return obj ? Object.keys(obj).length : 0;
  }

  constructor() { }

  ngOnInit(): void {
  }

   hasResultData(): boolean {
    return (this.result?.homeCareTips && Object.keys(this.result.homeCareTips).length > 0)
      || this.result?.labTests?.length > 0
      || this.result?.possibleConditions?.length > 0;
     //|| this.result?.whenToSeeDoctor?.length > 0;
  }

}
